module.exports = __webpack_public_path__ + "files/520e84c672682639130263665f486732.svg";